module.exports = __webpack_public_path__ + "img/teaser_traktor1.8b6ef114.jpg";